module.exports = __webpack_public_path__ + "img/2e00b26.svg";